import AppEvents from 'lib/AppEvents';
import CacheStore from 'lib/data/stores/Cache/CacheStore';
import EventService from 'services/EventService';
import { getLogger } from 'utils/logging';

const { log, warn } = getLogger('metrics', { color: 'blue', enabled: false });

class MetricService {
    private store: CacheStore;
    public listeners = [];

    constructor() {
        this.store = new CacheStore("MS_");
        this.bindEvents();
    }

    public bindEvents = () => {
        EventService.subscribe(AppEvents.LOGIN, async () => {
            await this.clearData();
        });
        EventService.subscribe(AppEvents.LOGOUT, async (d) => {
            await this.clearData();
        });
    }

    public clearData = async () => {
        await this.store.clear();
    }

    public set = (name: string, val: any) => {
        this.store.set(name, val);
    }

    // Looks for the current metric calculation, or recalculates.
    // Also used as a general storage point for cached data.
    public get = (name: string, def, recalculate = false) => {
        let metric = this.store.get(name);
        if (typeof metric == 'undefined') {
            log('!! METRIC NOT FOUND:', name);
            if (recalculate) {
                metric = recalculate(); // todo: re-calculate with passed in hook, or just add above
                this.store.set(name, metric);
            } else {
                metric = def;
            }
        }

        return metric;
    }

    // gets all the variables at once and returns as an object for easier destructuring.
    public getSet(metrics) {
        return metrics.reduce((r, m) => {
            r[m] = this.get(m);
            return r;
        }, {});
    }



    public subscribe = (dataSet, listener) => {
        let l = new ListenerDictionary(dataSet, listener);
        this.listeners.push(l);

        // emit immediately if data is already ready (ie. route change/remount);
        // Todo: this needs to check the specific data set, not entire thing.

        if (this.isLoaded()) {
            let _dataSet = this.getSet(dataSet);
            listener({
                status: 'ready',
                data: _dataSet
            });
        }
    }

    public unsubscribe = (dataSet, listener) => {
        for (let i = 0; i < this.listeners.length; i++) {
            let l = this.listeners[i];
            if (l.dataSet == dataSet && l.listener == listener) {
                this.listeners.splice(i, 1);
                break;
            }
        }
    }

    // // Todo: change to dynamic providers...
    // public loadData = (allData, user) => {
    //     return new Promise((resolve, reject) => {
    //         let fbData = allData[0];
    //         if (!fbData || !user) return reject(false);

    //         this.fbData = fbData;
    //         this.userData = user.metadata.goals; //AuthService.getCurrentUser();

    //         // enable/disable will detect duplicate variables names and warn, for dev.
    //         this.clearData();
    //         this.store.enableWarnings();

    //         setTimeout(() => {
    //             this.recalculate();
    //             this.store.disableWarnings();
    //             EventService.dispatch(AppEvents.DATA_LOADED, null);
    //             this._isLoaded = true;
    //             return resolve(true);
    //         });
    //     });
    // }

    // Todo: probably need to keep a 'dirty' bit on each of the data sets...
}

class DataSet {
    constructor(id, data) {
        this.id = id;
        this.data = data;
        this.isDirty = true;
    }

    public id: string;

    public data: any;

    // marked true if the data set was just loaded or reloaded (ie. new data that needs to be processed)
    public isDirty: boolean;

    // should take a generic method to recalculate and set the data for itself
    public recalculate: () => void;
}

class ListenerDictionary {

    constructor(dataSet, listener) {
        this.dataSet = dataSet;
        this.listener = listener;
    }

    // String of all properties to listen for. Properties can also be "sets" of data.
    dataSet: [string];

    // The listener which will handle the "data ready" action.
    listener: () => any;

}

export default new MetricService();